// Aqui terá a tela principal, com as opções "Cover Flow, Músicas..."

import React, { Component } from 'react';
// import APIscreen from './ApiScreen';

import MusicsScreen from './MusicsScreen';

let questions;
export default class MainScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            questions: [
                { id: 'fdsd', title: 'Why is the sky blue?' },
                { id: 'adsf', title: 'Who invented pizza?' },
                { id: 'afdsf', title: 'Is green tea overrated?' },
            ],
            displayQuestions: false
            // selectedScreen: ""
        }
    }

    selectScreen(param) {
        // https://stackoverflow.com/questions/46592833/how-to-use-switch-statement-inside-a-react-component
        switch(param) {
            case 'coverflow':
                return console.log('cover');
            case 'musicas':
                return <MusicsScreen />;
            default:
                return;
        }
    }

    // https://betterprogramming.pub/rendering-components-in-onclick-events-in-react-bc0d7b54e1cd
    displayQuestion = () => {
        this.setState({
            displayQuestions: !this.state.displayQuestions
        })

        if (this.state.displayQuestions) {
            questions = (
                <div>
                    { this.state.questions.map((question, index) => {
                        return <MusicsScreen />
                        // title={question.title}
                    })}
                </div>
            );
        }
    }

    ShowMenu = () => {
        if (!this.state.displayQuestions) {
            return(
                <div>
                    <p>Músicas</p>
                    <p>Jogos</p>
                    <p>Configurações</p>
                </div>
            );
        }
    }
    
    render(){
        return(
            <div>
                {/* <p>Cover Flow</p> */}
                <button className="btn" onClick={this.displayQuestion}>Cover Flow</button>
                {questions}
                <p>Músicas</p>
                <p>Jogos</p>
                <p>Configurações</p>
                {/* <this.ShowMenu /> */}
            </div>
        );
    }
}